import React from 'react'
import { UserLiveTalkLpTpl } from '../../../components/templates'
import { Meta } from '../../../Meta'

export const UserLiveTalkLp: React.FC = () => {
  return (
    <>
      <Meta />
      <UserLiveTalkLpTpl />
    </>
  )
}
